import React, { useEffect, useState, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import PaymentFilter from 'components/sales/ListFilters/PaymentFilter';
import LedgerFilter from 'components/sales/ListFilters/LedgerFilter';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';

const LedgerListing = ({
  getLedgerListing,
  ledgerlistData,
  getListFilterData,
  filterDropdownList = null,
  fetchZones,
  getFetchZones = null,
  match,
  history,
  downloadLedger
}) => {
  console.log('PAGE::LEDGER LIST');
  const [listData, setListData] = useState();
  const [activePostSales, setActivePostSales] = useState();
  const [teamId, setTeamId] = useState();
  const [departmentId, setDepartmentId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);
  const [isRoleId, setIsRoleId] = useState(null);
  const [showAddAdvancePopup, setShowAddAdvancePopup] = useState(false);
  const [currentBusinessId, setCurrentBusinessId] = useState('');
  const [currentInvoiceId, setCurrentInvoiceId] = useState('');
  const [currentContractId, setCurrentContractId] = useState('');
  const [currentSiteNumber, setCurrentSiteNumber] = useState('');
  const [currentBusinessName, setCurrentBusinessName] = useState('');
  const [currentContractType, setCurrentContractType] = useState('');

  useEffect(() => {
    (async () => {
      const roles = await JSON.parse(localStorage.getItem('roles'));
      roles && setIsRoleId(roles[0].pivot.role_id);
    })();
  }, []);


  useEffect(() => {
    (async () => {
      const team =
        (await JSON.parse(localStorage.getItem('profileDetails'))) &&
        JSON.parse(localStorage.getItem('profileDetails'))[0].team_id;
      const deparment =
        (await JSON.parse(localStorage.getItem('profileDetails'))) &&
        JSON.parse(localStorage.getItem('profileDetails'))[0].department_id;
      setTeamId(team);
      setDepartmentId(deparment);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getLedgerListing(match?.params?.recon_business_id,null, 1);
      setIsLoading(false);
    })();
  }, []);

  const headers = [
    'Invoice No.',
    'Type',
    'Description',
    'Amount',
    'Transaction Status',
    'Debit',
    'Credit',
    'Balance',
    'Created At'
  ];

  useEffect(() => {
    const tableData = [
        "id",
        "document_number",
        "type",
        "description",
        "amount",
        "txn_direction",
        "debit",
        "credit",
        "balance",
        "created",
    ];

    if (ledgerlistData !== undefined && ledgerlistData.resultSets) {
      const data = ledgerlistData.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            // Action: [
            //   { name: 'Add Advance', businessId: element?.business_id, businessName: element?.business, invoiceId: element?.invoice_id, contractId: element?.contract_id, siteNumber: element?.site_number, contractType: element?.contract_type },
            // ],
          }
        )
      );
      data && setListData(data);
      setPageCount(Math.ceil(ledgerlistData.total / ledgerlistData.per_page));
    }
  }, [ledgerlistData]);

  const applyFilter = async (filterData) => {
    console.log(filterData);
    setIsLoading(true);
    setFilterData(filterData);
    await getLedgerListing(match?.params?.recon_business_id, filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    (async () => {
      await getListFilterData(2);
    })();
  }, []);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const handleLedgerDownlaod = async (businessId, isPdf) => {
    if(businessId != null && businessId != undefined) {
       setIsLoading(true);
       const res = await downloadLedger(businessId,filterData,isPdf);
       if(res != false) {
          console.log(res + JSON.stringify(res));
          if(res?.response.data) {
            //  window.open(res?.response.data, '_self');
             window.open(res?.response.data, '_blank');
          } else {
            toast.error('Some error occur while downloading the file.');
          }
          setIsLoading(false);
       } 
       setIsLoading(false);
    }
  }

  const headerBtns = () => {
    return (
      <Fragment>
         {ledgerlistData && ledgerlistData?.resultSets?.length > 0 &&<>
            <Button
              onClick={() => handleLedgerDownlaod(match?.params?.recon_business_id, 1)}
              className="btn btn-primary"
              >PDF&nbsp;
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-cloud-arrow-down-fill" viewBox="0 0 16 16">
                <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708z"/>
              </svg>
           </Button> 
           <Button
           onClick={() => handleLedgerDownlaod(match?.params?.recon_business_id, 0)}
           className="btn btn-primary"
           >CSV&nbsp;
           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-cloud-arrow-down-fill" viewBox="0 0 16 16">
             <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708z"/>
           </svg>
        </Button> </>
         }
         <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          {/* <img src={Images?.Filter} alt="" /> */}
          {localization.showFilters}
        </Button> 
      </Fragment>
    );
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getLedgerListing(match?.params?.recon_business_id, filter, val.selected + 1);
    setIsLoading(false);
  };

  const getZones = (val) => {
    if (val) fetchZones(val);
  };

  const closeSuccess = () => {
    setIsLoading(true);
    setIsStatusSuccess(!isStatusSuccess);
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.ledgerList}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={false}
        headers={headers}
        detailList={ledgerlistData && ledgerlistData.resultSets}
        pageCount={pageCount}
        srNo={ledgerlistData?.from}
        onPageChange={onPageChange}
        setShowAddAdvancePopup={setShowAddAdvancePopup}
        setCurrentBusinessId={setCurrentBusinessId}
        setCurrentContractId={setCurrentContractId}
        setCurrentInvoiceId={setCurrentInvoiceId}
        setCurrentSiteNumber={setCurrentSiteNumber}
        setCurrentBusinessName={setCurrentBusinessName}
        setCurrentContractType={setCurrentContractType}
      />

      <LedgerFilter
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={'5'}
        getZones={(val) => getZones(val)}
        listFilterData={filterDropdownList && filterDropdownList.data}
        zones={getFetchZones && getFetchZones.data}
        isRoleId={isRoleId}
        siteFilters
      />
    </Layout>
  );
};

export default LedgerListing;
